import {
  v8CssVariablesResolver,
  type CSSVariablesResolver,
} from "@mantine/core";
import { shade } from "./colors";

export const themeV2CssVariablesResolver: CSSVariablesResolver = theme => {
  const base = v8CssVariablesResolver(theme);

  const overrides = {
    "--mantine-color-error": shade(theme.colors.error, 500),
    "--mantine-color-success": shade(theme.colors.success, 500),
    "--mantine-color-default-border": shade(theme.colors.ink, 200),
    "--mantine-color-disabled": shade(theme.colors.ink, 50),
    "--mantine-color-disabled-color": shade(theme.colors.ink, 400),
    "--mantine-color-text": shade(theme.colors.ink, 700),
    "--mantine-color-bright": shade(theme.colors.ink, 500),
    "--mantine-color-dimmed": shade(theme.colors.ink, 400),
    "--mantine-color-placeholder": shade(theme.colors.ink, 400),
    "--mantine-color-default-hover": shade(theme.colors.ink, 50),
  };

  return {
    ...base,
    light: { ...base.light, ...overrides },
    dark: { ...base.dark, ...overrides },
  };
};
